import React, { useEffect, useState } from 'react'
import { CustomTable } from '../../../../Components/Admin/CustomTable';
import { camposFormulario, camposFormularioCrear, columns } from './Helpers/listarUsuariosHelper';
import { useListarUsuariosTable, useCrearUsuario, useTipoUsuarioSelect, useRolesSelect } from '../../../../Hooks/Admin';
import { useDataUsuarioSelected } from '../../../../Hooks/Admin/useContextos';

export const ListarUsuarios = ({ setActiveKey }) => {

    const tipoUsuario = useTipoUsuarioSelect();
    const roles = useRolesSelect();
    const { setSelectedId } = useDataUsuarioSelected();

    const [listarTipos, setListarTipos] = useState(null)
    const [listarRoles, setListarRoles] = useState(null)

    useEffect(() => {
        setearData();
    }, [])

    const setearData = async () => {
        const tipos = await tipoUsuario.refetch();
        const role = await roles.refetch();

        setListarRoles(role.data);
        setListarTipos(tipos.data);
    }

    const moveTab = (data) => {
        setActiveKey("data");
        setSelectedId(data.id);
    }

    return (
        <>
            <CustomTable
                camposFilter={camposFormulario(listarTipos, listarRoles)}
                queryListar={useListarUsuariosTable}
                camposAgregar={camposFormularioCrear(listarTipos, listarRoles)}
                camposFormularioModal={camposFormularioCrear(listarTipos, listarRoles)}
                columns={columns(moveTab)}
                editable={false}
                perPage={5}
                detalle={true}
                queryCrear={useCrearUsuario}
                queryEditar={useCrearUsuario}
            />
        </>
    );
}
